import React from 'react';
import { Route } from 'react-router-dom';
import { CommonModule } from "uca-react-containers-library";

function WebViewRoute({ component: Component, title, banner, ...rest }) {
    document.title = `${title} | ${banner}`;
    return (
        <CommonModule.WebViewProvider>
            <CommonModule.RouteProvider>
                <Route {...rest} render={props => <Component {...props} />} />
            </CommonModule.RouteProvider>
        </CommonModule.WebViewProvider>
    );
}

export default WebViewRoute;